import { render, staticRenderFns } from "./BonusList.vue?vue&type=template&id=2444d186&scoped=true"
import script from "./BonusList.vue?vue&type=script&lang=js"
export * from "./BonusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444d186",
  null
  
)

export default component.exports